// Web Vitals monitoring for Core Web Vitals tracking
// This helps measure the impact of performance optimizations

export interface WebVitalsMetric {
  name: string;
  value: number;
  rating: 'good' | 'needs-improvement' | 'poor';
  delta: number;
  id: string;
}

// Track and log Web Vitals metrics
export const reportWebVitals = (metric: WebVitalsMetric) => {
  // Log to console in development
  if (import.meta.env.DEV) {
    console.log(`[Web Vitals] ${metric.name}:`, {
      value: metric.value,
      rating: metric.rating,
      id: metric.id,
    });
  }

  // In production, you could send this to an analytics service
  // Example: sendToAnalytics(metric);
};

// Initialize web vitals tracking
export const initWebVitals = async () => {
  if ('web-vital' in window || import.meta.env.DEV) {
    try {
      const { onCLS, onINP, onFCP, onLCP, onTTFB } = await import('web-vitals');
      
      onCLS(reportWebVitals);
      onINP(reportWebVitals); // INP replaced FID in web-vitals v4
      onFCP(reportWebVitals);
      onLCP(reportWebVitals);
      onTTFB(reportWebVitals);
    } catch (error) {
      console.error('Failed to load web-vitals:', error);
    }
  }
};
